export default __webpack_public_path__ + "static/media/blue-candy.cf1a8372.png";